// extracted by mini-css-extract-plugin
export default {"famousPersonsContainer":"FamousPersons_famousPersonsContainer__ihg9M","famousPersonsCellContainer":"FamousPersons_famousPersonsCellContainer__10h+N"};